// extracted by mini-css-extract-plugin
export var bottomRightDock = "_z-0";